import get from 'transmute/get';
export const getTypingMessageStyle = get('style');